import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Home', exact: true },
    { path: '/releases', label: 'Releases' },
    { path: '/videos', label: 'Videos' },
    { path: '/about-songs', label: 'Song Stories' },
    { path: '/about-me', label: 'About' },
    { path: '/media', label: 'Media' }
  ];

  const isActive = (path, exact = false) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="bg-[#16213e] border-b border-[#e94560]">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-wrap justify-center gap-1">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`px-3 py-2 text-sm md:text-base transition-colors ${
                isActive(item.path, item.exact)
                  ? 'text-white bg-[#e94560]'
                  : 'text-gray-400 hover:text-white hover:bg-[#1a1a2e]'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
